"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const assets_1 = require("~/assets");
const UI_1 = require("~/components/UI");
const utils_1 = require("~/utils/utils");
const BOMAssemblyChargeItem_1 = __importDefault(require("../BOMAssemblyChargeItem"));
const BOMItemPrice_1 = __importDefault(require("../BOMItemPrice"));
const PriceTooltip_1 = __importDefault(require("../PriceTooltip"));
const BOMAssemblyCharge_scss_1 = __importDefault(require("./BOMAssemblyCharge.scss"));
function BOMAssemblyCharge({ assemblyCharge, lineItemNumber }) {
    var _a, _b;
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(false);
    const [isDescriptionOverflowing, setDescriptionOverflowing] = (0, react_1.useState)(false);
    const assemblyChargeIconSrc = '../../../../assets/icons/assembly-icon.png';
    const clickHandler = () => setIsExpanded((current) => !current);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: BOMAssemblyCharge_scss_1.default.item },
            react_1.default.createElement("div", { className: isExpanded ? `${BOMAssemblyCharge_scss_1.default.arrow} ${BOMAssemblyCharge_scss_1.default.expanded}` : BOMAssemblyCharge_scss_1.default.arrow }, ((_a = assemblyCharge.items) === null || _a === void 0 ? void 0 : _a.length) && (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
            react_1.default.createElement("img", { src: assets_1.svgSystemChevronRight, onClick: clickHandler, alt: "chevron right " }))),
            react_1.default.createElement("div", { className: BOMAssemblyCharge_scss_1.default.itemLineItem }, lineItemNumber),
            react_1.default.createElement("div", { className: BOMAssemblyCharge_scss_1.default.itemImg },
                react_1.default.createElement(UI_1.Image, { src: assemblyChargeIconSrc })),
            react_1.default.createElement("div", { className: BOMAssemblyCharge_scss_1.default.itemNumber }, `#${assemblyCharge.item_number}`),
            react_1.default.createElement("div", { className: BOMAssemblyCharge_scss_1.default.itemDescription, onMouseOver: (e) => setDescriptionOverflowing((0, utils_1.isEventTargetOverflowing)(e)), onFocus: (e) => setDescriptionOverflowing((0, utils_1.isEventTargetOverflowing)(e)) },
                react_1.default.createElement(UI_1.Tooltip, { placement: "right-end", contentNode: react_1.default.createElement("div", { className: BOMAssemblyCharge_scss_1.default.tooltip }, assemblyCharge.description), disabled: !isDescriptionOverflowing },
                    react_1.default.createElement("div", { className: BOMAssemblyCharge_scss_1.default.itemTextWithEllipsis }, assemblyCharge.description))),
            react_1.default.createElement("div", { className: BOMAssemblyCharge_scss_1.default.itemQuantity }, (_b = assemblyCharge.quantity) === null || _b === void 0 ? void 0 : _b.toFixed(2)),
            react_1.default.createElement(PriceTooltip_1.default, { price: assemblyCharge.price, unitOfMeasurement: assemblyCharge.unitOfMeasurement || '' }),
            react_1.default.createElement(BOMItemPrice_1.default, { price: assemblyCharge.sum || 0, discountedPrice: assemblyCharge.discountedSum })),
        assemblyCharge.items && assemblyCharge.items.length > 0 && isExpanded && (react_1.default.createElement(BOMAssemblyChargeItem_1.default, { assemblyChargeItems: assemblyCharge.items, parentLineItemNumber: lineItemNumber }))));
}
exports.default = BOMAssemblyCharge;
